/**
  Promise wrap around setTimeout
*/
const waitFor = ms => new Promise(accept => setTimeout(() => accept(), ms))

export default waitFor
